/**
 * Represents different sections of thank you page (both for purchase and opt in pages)
 */
export const THANKYOU_PAGE_SECTION_SLUGS = {
  CONFIRMATION: "Confirmation",
  REDIRECTION: "Redirection",
  UPSELL: "Upsell",
  TESTIMONIAL: "Testimonials",
  ANALYTICS: "Analytics",
};
